import companySpecificTrainingDetailsLocale from './en.json'

const en = {
  companySpecificTrainingDetails: companySpecificTrainingDetailsLocale,
}

export default en
